import { render, staticRenderFns } from "./PopupQRHistory.vue?vue&type=template&id=bb5a504c&scoped=true"
import script from "./PopupQRHistory.vue?vue&type=script&lang=js"
export * from "./PopupQRHistory.vue?vue&type=script&lang=js"
import style0 from "./PopupQRHistory.vue?vue&type=style&index=0&id=bb5a504c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5a504c",
  null
  
)

export default component.exports